// extracted by mini-css-extract-plugin
export var numpadContainer = "_oc-1";
export var phoneButton = "_oc-0";